import { render, staticRenderFns } from "./Ledger.vue?vue&type=template&id=5104d490&"
import script from "./Ledger.vue?vue&type=script&lang=ts&"
export * from "./Ledger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports